import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

import * as L from 'leaflet';

import { CountryOrdersMapService } from './country-orders-map.service';
import { NbThemeService } from '@nebular/theme';
import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { stringify } from 'querystring';
import { Router } from '@angular/router';


@Component({
  selector: 'ngx-country-orders-map',
  styleUrls: ['./country-orders-map.component.scss'],
  template: `
    <div leaflet [leafletOptions]="options" [leafletLayers]="layers" (leafletMapReady)="mapReady($event)"></div>
  `,
})
export class CountryOrdersMapComponent implements OnDestroy {

  @Input() countryId: string;

  @Output() select: EventEmitter<any> = new EventEmitter();

  layers = [];
  currentTheme: any;
  alive = true;
  selectedCountry;

  bubbleJson: {name: string,latitude: number,longitude: number, value: number}[];

  noirBubbleIcon = L.icon({
    iconUrl: 'assets/icons/black-circle.png',
    iconSize:     [4, 4], // size of the icon
  });
  pinkBubbleIcon = L.icon({
    iconUrl: 'assets/icons/pink-circle.png',
    iconSize:     [7, 7], 
  });
  purpleBubbleIcon = L.icon({
    iconUrl: 'assets/icons/purple-circle.png',
    iconSize:     [10, 10], 
  });
  blueBubbleIcon = L.icon({
    iconUrl: 'assets/icons/blue-circle.png',
    iconSize:     [13, 13], 
  });
  greenBubbleIcon = L.icon({
    iconUrl: 'assets/icons/green-circle.png',
    iconSize:     [16, 16], // size of the icon
  });
  yellowBubbleIcon = L.icon({
    iconUrl: 'assets/icons/yellow-circle.png',
    iconSize:     [19, 19], // size of the icon
  });
  orangeBubbleIcon = L.icon({
    iconUrl: 'assets/icons/orange-circle.png',
    iconSize:     [22, 22], // size of the icon
  });
  redBubbleIcon = L.icon({
    iconUrl: 'assets/icons/red-circle.png',
    iconSize:     [25, 25], // size of the icon
  });

  options = {
    zoom: 2,
    minZoom: 1,
    maxZoom: 6,
    zoomControl: false,
    center: L.latLng({lat: 38.991709, lng: -76.886109}),
    maxBounds: new L.LatLngBounds(
      new L.LatLng(-89.98155760646617, -180),
      new L.LatLng(89.99346179538875, 180),
    ),
    maxBoundsViscosity: 1.0,
  };

  constructor(private ecMapService: CountryOrdersMapService,
              private theme: NbThemeService,
              private route: Router) {

    combineLatest([
      this.ecMapService.getCords(),
      this.theme.getJsTheme(),
    ])
      .pipe(takeWhile(() => this.alive))
      .subscribe(([cords, config]: [any, any]) => {
        this.currentTheme = config.variables.countryOrders;
        this.layers = [this.createGeoJsonLayer(cords)];
        this.selectFeature(this.findFeatureLayerByCountryId(this.countryId));
      });
  }


  mapReady(map: L.Map) {
    map.addControl(L.control.zoom({position: 'bottomright'}));
    this.ecMapService.getBubbles()
      .pipe(takeWhile(() => this.alive))
      .subscribe((jsonInfo) => {
        this.bubbleJson = jsonInfo.worldbubble;
        console.log("bubbleJson", this.bubbleJson);
        this.setBubble(map, this.bubbleJson);
      });
    // fix the map fully displaying, existing leaflet bag
    setTimeout(() => {
      map.invalidateSize();
    }, 0);
  }
  
  setCircle(map: L.Map, bubbleJsonList: any[]){
    for (let i = 0; i < bubbleJsonList.length; i++) {
      if (bubbleJsonList[i].value === "" ||  bubbleJsonList[i].latitude === "" ||  bubbleJsonList[i].longitude === "") {
      } else {
        if (bubbleJsonList[i].value < 5) {
          L.circle([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {color:'black',fillColor: '#000000',fillOpacity: 0.5,radius: 250}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 5 && bubbleJsonList[i].value < 15) {
          L.circle([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {fillColor: '#ffccff',fillOpacity: 0.5,radius: 500}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 15 && bubbleJsonList[i].value < 30) {
          L.circle([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {fillColor: '#993399',fillOpacity: 0.5,radius: 750}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 30 && bubbleJsonList[i].value < 45) {
          L.circle([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {fillColor: '#0000ff',fillOpacity: 0.5,radius: 1000}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 45 && bubbleJsonList[i].value < 60) {
          L.circle([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {fillColor: '#009933',fillOpacity: 0.5,radius: 1250}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 60 && bubbleJsonList[i].value < 80) {
          L.circle([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {fillColor: '#ffff00',fillOpacity: 0.5,radius: 1500}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 80 && bubbleJsonList[i].value < 100) {
          L.circle([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {fillColor: '#e68a00',fillOpacity: 0.5,radius: 1750}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 100 ) {
          L.circle([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {color:'red', fillColor: '#f30',fillOpacity: 0.5,radius: 2000}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        }
      }
    }
  }
  setBubble(map: L.Map, bubbleJsonList: any[]){
    for (let i = 0; i < bubbleJsonList.length; i++) {
      if (bubbleJsonList[i].value === "" ||  bubbleJsonList[i].latitude === "" ||  bubbleJsonList[i].longitude === "") {
      } else {
        if (bubbleJsonList[i].value < 5) {
          L.marker([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {icon: this.noirBubbleIcon}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 5 && bubbleJsonList[i].value < 15) {
          L.marker([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {icon: this.pinkBubbleIcon}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 15 && bubbleJsonList[i].value < 30) {
          L.marker([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {icon: this.purpleBubbleIcon}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 30 && bubbleJsonList[i].value < 45) {
          L.marker([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {icon: this.blueBubbleIcon}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 45 && bubbleJsonList[i].value < 60) {
          L.marker([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {icon: this.greenBubbleIcon}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 60 && bubbleJsonList[i].value < 80) {
          L.marker([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {icon: this.yellowBubbleIcon}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 80 && bubbleJsonList[i].value < 100) {
          L.marker([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {icon: this.orangeBubbleIcon}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        } else if (bubbleJsonList[i].value >= 100 ) {
          L.marker([bubbleJsonList[i].latitude, bubbleJsonList[i].longitude], {icon: this.redBubbleIcon}).addTo(map)
          .bindPopup(bubbleJsonList[i].name + " : " + bubbleJsonList[i].value);
        }
      }
    }
  }

  private createGeoJsonLayer(cords) {
    return L.geoJSON(
      cords as any,
      {
        style: () => ({
          weight: this.currentTheme.countryBorderWidth,
          fillColor: this.currentTheme.countryFillColor,
          fillOpacity: 1,
          color: this.currentTheme.countryBorderColor,
          opacity: 1,
        }),
        onEachFeature: (f, l) => {
          this.onEachFeature(f, l);
        },
      });
  }

  private onEachFeature(feature, layer) {
    layer.on({
      mouseover: (e) => this.highlightFeature(e.target) ,
      mouseout: (e) => this.moveout(e.target),
      click: (e) => this.selectFeature(e.target),

    });
  }

  private highlightFeature(featureLayer) {
    if (featureLayer) {
      featureLayer.setStyle({
        weight: this.currentTheme.hoveredCountryBorderWidth,
        fillColor: this.currentTheme.hoveredCountryFillColor,
        color: this.currentTheme.hoveredCountryBorderColor,
      });

      if (!L.Browser.ie && !L.Browser.opera12 && !L.Browser.edge) {
        featureLayer.bringToFront();
      }
    }
  }

  private moveout(featureLayer) {
    if (featureLayer !== this.selectedCountry) {
      this.resetHighlight(featureLayer);

      // When countries have common border we should highlight selected country once again
      this.highlightFeature(this.selectedCountry);
    }
  }

  private resetHighlight(featureLayer) {
    if (featureLayer) {
      const geoJsonLayer = this.layers[0];

      geoJsonLayer.resetStyle(featureLayer);
    }
  }

  private selectFeature(featureLayer) {
      // L.popup()
      // .setLatLng(featureLayer.latlng)
      // .bindPopup("You clicked at " + featureLayer.latlng.toString())
      // .openPopup();
    if (featureLayer !== this.selectedCountry) {
      this.resetHighlight(this.selectedCountry);
      this.highlightFeature(featureLayer);
      this.selectedCountry = featureLayer;
      this.select.emit(featureLayer.feature.properties.name);
    }
  }

  /* private getRouterLinkFromCountryName(bubbleListObject: any){
    let countryName: string = bubbleListObject;
    let countryURL: string = '<a href="https://www.openstreetmap.org/">bubbleListObject</a>'
    //this.route.navigate(['/pages/country-content'],  { state: { countryType: '' , countryName: this.countryName } });
    return countryURL;
  } */

  private findFeatureLayerByCountryId(id) {
    const layers = this.layers[0].getLayers();
    const featureLayer = layers.find(item => {
      return item.feature.id === id;
    });

    return featureLayer ? featureLayer : null;
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

}
